import { render, staticRenderFns } from "./RegistInformation.vue?vue&type=template&id=06846e9e&scoped=true&"
import script from "./RegistInformation.vue?vue&type=script&lang=js&"
export * from "./RegistInformation.vue?vue&type=script&lang=js&"
import style0 from "./RegistInformation.vue?vue&type=style&index=0&id=06846e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06846e9e",
  null
  
)

export default component.exports